// extracted by mini-css-extract-plugin
var _1 = "sCkejrCYtt";
export { _1 as "staticText" }
